import React from 'react'
import Code from './code'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import styled, { createGlobalStyle } from 'styled-components'
import { giphyDarkCharcoal, giphyGreen, giphyDarkestGrey, giphyLightGrey } from '../styles/colors'

const SCodeStyle = createGlobalStyle`
    .language-python, .language-javascript, .language-bash, .language-php, .language-ruby {
        margin: 0;
        padding: 0 0 2em 2em;
        color: #ffffff;
    }
    
    #tabs span {
        top:-30px;
    }
`

const STabs = styled(Tabs)`
    font-weight: bold;
    margin-bottom: 40px;
`

const STabPanel = styled(TabPanel)`
    display: none;
    border-bottom: 1px solid ${giphyDarkCharcoal};

    &.is-selected {
        display: block;
    }
`

const STab = styled(Tab)`
    margin-right: 30px;
    padding: 0.5em 0;
    cursor: pointer;

    &.is-selected {
        border-bottom: 1px solid ${giphyGreen};
        color: ${giphyGreen};
    }

    &:focus {
        outline: none;
        border-bottom: 1px solid ${giphyGreen};
        color: ${giphyGreen};
    }
`

const STabList = styled(TabList)`
    list-style-type: none;
    padding: 0 0 0 30px;
    display: flex;
    letter-spacing: 0;
    color: ${giphyLightGrey};
    margin: 0;
    border-bottom: 1px solid ${giphyDarkCharcoal};
`

const Collect = styled.div`
    width: 100%;
    background-color: ${giphyDarkestGrey};
    font-size: 14px;
    position: relative;
`

const JSExample = `//javascript, jQuery

var xhr = $.get("http://api.giphy.com/v1/gifs/search?q=ryan+gosling&api_key=YOUR_API_KEY&limit=5");
xhr.done(function(data) { console.log("success got data", data); });
`

const PhpExample = `// php

$url = "http://api.giphy.com/v1/gifs/search?q=ryan+gosling&api_key=YOUR_API_KEY&limit=5";
print_r(json_decode(file_get_contents($url)));
`

const PythonExample = `# python

import urllib,json
data=json.loads(urllib.urlopen("http://api.giphy.com/v1/gifs/search?q=ryan+gosling&api_key=YOUR_API_KEY&limit=5").read())
print json.dumps(data, sort_keys=True, indent=4)
`

const RubyExample = `#ruby

require 'net/http'
require 'json'
url="http://api.giphy.com/v1/gifs/search?q=ryan+gosling&api_key=YOUR_API_KEY&limit=5"
resp = Net::HTTP.get_response(URI.parse(url))
buffer = resp.body
result = JSON.parse(buffer)
puts result
`

const ShellExample = `# curl, command line

curl "http://api.giphy.com/v1/gifs/search?q=ryan+gosling&api_key=YOUR_API_KEY&limit=5"
`

const CodeSwitcher = () => {
    return (
        <Collect>
            <SCodeStyle />
            <STabs selectedTabClassName="is-selected" selectedTabPanelClassName="is-selected" id="tabs">
                <STabList>
                    <STab>Python</STab>
                    <STab>Javascript</STab>
                    <STab>Ruby</STab>
                    <STab>PHP</STab>
                    <STab>Bash</STab>
                </STabList>
                <STabPanel>
                    <Code language="python" showLineNumber>
                        {PythonExample}
                    </Code>
                </STabPanel>
                <STabPanel>
                    <Code language="javascript" showLineNumber>
                        {JSExample}
                    </Code>
                </STabPanel>
                <STabPanel>
                    <Code language="ruby" showLineNumber>
                        {RubyExample}
                    </Code>
                </STabPanel>
                <STabPanel>
                    <Code language="php" showLineNumber>
                        {PhpExample}
                    </Code>
                </STabPanel>
                <STabPanel>
                    <Code language="bash" showLineNumber>
                        {ShellExample}
                    </Code>
                </STabPanel>
            </STabs>
        </Collect>
    )
}

export default CodeSwitcher
